import RichText from '@eneco/components/RichText/RichText';
import { IconList, IconLoader } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';

export const BrandBenefitsCard = () => {
  const { fields } = useContent<DashboardOverviewRendering>();
  const brands = [
    {
      content: fields.brandBenefitsCard.benefitOneContent.value,
    },
    {
      content: fields.brandBenefitsCard.benefitTwoContent.value,
    },
    {
      content: fields.brandBenefitsCard.benefitThreeContent.value,
    },
    {
      content: fields.brandBenefitsCard.benefitFourContent.value,
    },
  ];
  return (
    <StyledDashboardBlock>
      <IconList>
        {brands.map(brand => (
          <IconList.Item key={brand.content} icon={<IconLoader iconName="CheckIcon" color="feedbackSuccess" />}>
            <RichText html={brand.content} />
          </IconList.Item>
        ))}
      </IconList>
      <DashboardLink
        href={fields.brandBenefitsCard?.changeLink.value.href}
        emphasis="high"
        trackingComponentName="brand_benefits_change_link"
        trackingComponentType="dashboard_link">
        {fields.brandBenefitsCard?.changeLink.value.text}
      </DashboardLink>
    </StyledDashboardBlock>
  );
};
